import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { message } from "antd";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const downloadSampleStudent = createAsyncThunk(
  "api/fetchData",
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/sample/download?fileIdentifier=BULK_USER_SAMPLE_FILE`,

        {
          headers: {
            Accept: "application/json",
            Authorization: token,
          },
        }
      );
      let status = "success";
      let data = {
        status: status,
        message: response.data,
      };

      // Convert the response to a Blob (binary data)
      const blob = await response.blob();

      // Create a Blob URL from the Blob data
      const blobUrl = URL.createObjectURL(blob);

      // Create a temporary <a> element to trigger the download
      const a = document.createElement("a");
      a.href = blobUrl; // Set the Blob URL
      a.download = "downloaded-file.xlsx"; // Specify the filename

      // Append the link to the document and trigger the download
      document.body.appendChild(a);
      a.click();
      a.remove(); // Clean up the DOM

      // Revoke the Blob URL to free memory
      URL.revokeObjectURL(blobUrl);

      return data; // Success: return data
    } catch (error) {
      // Handle error: rejectWithValue ensures proper error handling
      let status = "error";
      let data = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data;
    }
  }
);

const downloadStudentSlice = createSlice({
  name: "api",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(downloadSampleStudent.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(downloadSampleStudent.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(downloadSampleStudent.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default downloadStudentSlice.reducer;
